export const ALL_COOKIES_ACCEPTED = 'all'
export const COOKIE_NAME = 'glotio_gdpr_consent'
export const PARTIAL_COOKIES_ACCEPTED = 'partial'